module.exports = __webpack_public_path__ + "static/hymots-c-1-f4984f8fffa27f186c78eac984ce7bee.png";